import styles from './Loader.module.scss';
import cn from 'classnames';

type LoaderProps = {
  fullScreen?: boolean;
  className?: string;
};

export function Loader({ fullScreen = false, className }: LoaderProps) {
  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.fullScreen]: fullScreen,
    },
    className,
  );

  return (
    <div className={wrapperClassName}>
      <div className={styles.loader}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
